<mat-tab-group (selectedTabChange)="selectedTabChange($event)" mat-stretch-tabs="false" mat-align-tabs="left"
  class="performance-tab-group">
  <mat-tab label="Gallring"></mat-tab>
  <mat-tab label="Föryngringsavverkning"></mat-tab>
</mat-tab-group>

<section class="table-container mat-elevation-z8" [ngClass]="{'fm-readonly-mat-form-field' : isReadonly}">
  <table mat-table [dataSource]="currentPerformanceDataSource" class="mat-elevation-z8 machine-performances-table"
    matSort>
    <ng-container matColumnDef="meanStemVolumeInM3FubPerTree-c">
      <th mat-header-cell *matHeaderCellDef>Medelstam (m3fub/träd)</th>
      <td mat-cell *matCellDef="let element">
        <mat-form-field [appearance]="isReadonly ? 'fill': 'outline'" floatLabel="always" subscriptSizing="dynamic">
          <input matInput [value]="element.meanStemVolumeInM3FubPerTree" type="number" min="0"
            [(ngModel)]="element.meanStemVolumeInM3FubPerTree" (ngModelChange)="onRowChanged(element)"
            [readonly]="!isPolicyPt">
        </mat-form-field>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        <mat-form-field [appearance]="isReadonly ? 'fill': 'outline'" floatLabel="always" subscriptSizing="dynamic">
          <input matInput [(ngModel)]="newRow.meanStemVolumeInM3FubPerTree" type="number" min="0"
            [readonly]="!isPolicyPt">
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="transportDistanceForwarding-c">
      <th mat-header-cell *matHeaderCellDef>Trp avst(m)</th>
      <td mat-cell *matCellDef="let element">
        <mat-form-field [appearance]="isReadonly ? 'fill': 'outline'" floatLabel="always" subscriptSizing="dynamic">
          <input matInput [value]="element.transportDistanceForwarding" type="number" min="0"
            [(ngModel)]="element.transportDistanceForwarding" (ngModelChange)="onRowChanged(element)"
            [readonly]="!isPolicyPt">
        </mat-form-field>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        <mat-form-field [appearance]="isReadonly ? 'fill': 'outline'" floatLabel="always" subscriptSizing="dynamic">
          <input matInput [(ngModel)]="newRow.transportDistanceForwarding" type="number" min="0"
            [readonly]="!isPolicyPt">
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="g5InM3FubPerHour-c">
      <th mat-header-cell *matHeaderCellDef>G5 (m3fub/tim)</th>
      <td mat-cell *matCellDef="let element">
        <mat-form-field [appearance]="isReadonly ? 'fill': 'outline'" floatLabel="always" subscriptSizing="dynamic">
          <input matInput [value]="element.g5InM3FubPerHour" type="number" min="0"
            [(ngModel)]="element.g5InM3FubPerHour" (ngModelChange)="onRowChanged(element)" [readonly]="!isPolicyPt">
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef>
        <mat-form-field [appearance]="isReadonly ? 'fill': 'outline'" floatLabel="always" subscriptSizing="dynamic">
          <input matInput [(ngModel)]="newRow.g5InM3FubPerHour" type="number" min="0">
        </mat-form-field>
      </td>

    </ng-container>

    <ng-container matColumnDef="action-c">
      <th mat-header-cell *matHeaderCellDef>
      </th>

      <td mat-cell *matCellDef="let element; let i = index;">
        <div class="button-container">
          <button class="action-button" mat-raised-button (click)="removeRow(element, i)">
            Ta bort
          </button>
        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        <div class="button-container">
          <button class="action-button" mat-raised-button (click)="addNewRow()" [disabled]="this.newRowIsEmpty()">
            Lägg till
          </button>
        </div>
      </td>

    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
    <tr mat-row [hidden]="row?.clientStatus == clientStatus.Deleted" *matRowDef="let row; columns: displayedColumns;">
    </tr>
    @if(this.isPolicyPt) {
    <tr mat-footer-row *matFooterRowDef="displayedColumns" class="table-footer-row"></tr>
    }
  </table>

</section>